module.exports = __webpack_public_path__ + "fonts/roboto-condensed-all-300-italic.394447c7.woff2";